import moment from "moment";

const filterCaseInsensitive = (filter, row) => {
    const id = filter.pivotId || filter.id;

    if (filter.value === null || filter.value === undefined || filter.value === "") {
        return true;
    }

    const rawValue = row[id] !== undefined && row[id] !== null
        ? row[id]
        : row._original?.[id];

    const rowValue = rawValue !== undefined && rawValue !== null
        ? rawValue.toString().toLowerCase()
        : null;

    const constFilterValue = filter.value !== null
        ? filter.value.toString().toLowerCase()
        : null;

    if (id === "startDate") {
        if (constFilterValue === null) {
            return true;
        }
        return rowValue >= constFilterValue;
    } else if (id === "endDate") {
        if (constFilterValue === null) {
            return true;
        }
        return rowValue <= constFilterValue;
    }

    if (typeof filter.value === "object") {
        if (Array.isArray(filter.value) && filter.value.length === 1 && filter.value[0] === "") {
            return true;
        }

        if (moment.isMoment(filter.value) && filter.value && row[id]) {
            return moment(filter.value).format("YYYY-MM-DD") === row[id];
        } else if (row[id] !== undefined && filter.value) {
            return filter.value.indexOf(row[id]) > -1;
        } else {
            return true;
        }
    }

    return rowValue !== null
        ? rowValue.includes(constFilterValue)
        : false;
};
export default filterCaseInsensitive;
